/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Synthetic_Voice_LabelInputs */

const en_paste_attributes_synthetic_voice_label = /** @type {(inputs: Paste_Attributes_Synthetic_Voice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synthetic Voice`)
};

const fr_paste_attributes_synthetic_voice_label = /** @type {(inputs: Paste_Attributes_Synthetic_Voice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voix synthetique`)
};

const de_paste_attributes_synthetic_voice_label = /** @type {(inputs: Paste_Attributes_Synthetic_Voice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synthetische Stimme`)
};

const it_paste_attributes_synthetic_voice_label = /** @type {(inputs: Paste_Attributes_Synthetic_Voice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voce sintetica`)
};

const ru_paste_attributes_synthetic_voice_label = /** @type {(inputs: Paste_Attributes_Synthetic_Voice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Синтетический голос`)
};

const es_paste_attributes_synthetic_voice_label = /** @type {(inputs: Paste_Attributes_Synthetic_Voice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voz sintética`)
};

const zh_cn2_paste_attributes_synthetic_voice_label = /** @type {(inputs: Paste_Attributes_Synthetic_Voice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合成语音`)
};

const ja_paste_attributes_synthetic_voice_label = /** @type {(inputs: Paste_Attributes_Synthetic_Voice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合成音声`)
};

const hi_paste_attributes_synthetic_voice_label = /** @type {(inputs: Paste_Attributes_Synthetic_Voice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृत्रिम आवाज`)
};

const pt_pt2_paste_attributes_synthetic_voice_label = /** @type {(inputs: Paste_Attributes_Synthetic_Voice_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voz Sintética`)
};

/**
* | output |
* | --- |
* | "Synthetic Voice" |
*
* @param {Paste_Attributes_Synthetic_Voice_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_synthetic_voice_label = /** @type {((inputs?: Paste_Attributes_Synthetic_Voice_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Synthetic_Voice_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_paste_attributes_synthetic_voice_label(inputs)
	if (locale === "de") return de_paste_attributes_synthetic_voice_label(inputs)
	if (locale === "it") return it_paste_attributes_synthetic_voice_label(inputs)
	if (locale === "ru") return ru_paste_attributes_synthetic_voice_label(inputs)
	if (locale === "es") return es_paste_attributes_synthetic_voice_label(inputs)
	if (locale === "zh-CN") return zh_cn2_paste_attributes_synthetic_voice_label(inputs)
	if (locale === "ja") return ja_paste_attributes_synthetic_voice_label(inputs)
	if (locale === "hi") return hi_paste_attributes_synthetic_voice_label(inputs)
	if (locale === "pt-PT") return pt_pt2_paste_attributes_synthetic_voice_label(inputs)
	return en_paste_attributes_synthetic_voice_label(inputs)
});